import { LocalStorageCapsule } from 'data-capsule';

let _dataCapsule: ReturnType<typeof LocalStorageCapsule>;
export const getDataCapsule = () => {
  if (!_dataCapsule) {
    _dataCapsule = LocalStorageCapsule({
      namespace: 'marketplace-template-recommendations',
    });
  }

  return _dataCapsule;
};

export const RECOMMENDED_TEMPLATE_ENTRY_KEY = 'recommended_template_entry';
